import { Primary } from '@cinch-labs/design-system'
import styles from './hero-cta-button.module.css'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export type HeroCtaButtonProps = {
  label: string
  url: string
}

export const HeroCtaButton: React.FC<HeroCtaButtonProps> = ({ label, url }) => {
  const { trackEvent } = useAnalytics()
  const formattedLabel = label.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()

  const handleAppStoreClick = () => {
    trackEvent({
      eventName: label + ' - click',
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'hero',
          label: formattedLabel,
          action: 'navigate',
        },
      },
    })
    window.location.href = url
  }

  return (
    <Primary
      variant="alternative"
      onClick={handleAppStoreClick}
      classNames={{ button: styles.button }}
    >
      {label}
    </Primary>
  )
}
